import { render, staticRenderFns } from "./KolList.vue?vue&type=template&id=08b977d3&scoped=true"
import script from "./KolList.vue?vue&type=script&lang=js"
export * from "./KolList.vue?vue&type=script&lang=js"
import style0 from "./KolList.vue?vue&type=style&index=0&id=08b977d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b977d3",
  null
  
)

export default component.exports